import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type {
  ISettingAffiliateBannerResponse,
} from '@modules/general-settings/submodules/affiliate-banner/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { useCurrentNamespace } from '@modules/permissions/composables';
import { usePermissionsStore } from '@modules/permissions/store';
import { useTokensQuery } from '@modules/tokens/queries';

import {
  AFFILIATE_BANNER_API_URL,
  AFFILIATE_BANNER_PERMISSIONS,
  AFFILIATE_BANNER_QUERY,
} from '../constants';

export default function useAffiliateBannerQuery(): IContextQueryResult<ISettingAffiliateBannerResponse> {
  const { fetchGet } = useRestClient();
  const { isAffiliateNamespace } = useCurrentNamespace();
  const { hasPermission } = usePermissionsStore();
  const { data: token } = useTokensQuery();

  return useContextQuery<ISettingAffiliateBannerResponse>({
    queryKey: [AFFILIATE_BANNER_QUERY],
    queryFn: ({ signal }) => fetchGet<ISettingAffiliateBannerResponse>(
      AFFILIATE_BANNER_API_URL,
      {
        signal,
        permission: AFFILIATE_BANNER_PERMISSIONS.SHOW,
      },
    ),
    enabled: computed(() => isAffiliateNamespace.value && !token.value?.supervision && hasPermission(AFFILIATE_BANNER_PERMISSIONS.SHOW).value),
  });
}
